// import React from "react";
// import { motion } from "framer-motion";
// import { FaHandsHelping, FaLightbulb, FaBuilding } from "react-icons/fa";
// import styles from "../assets/styles/OpenToWork.module.css";

// const opportunities = [
//   {
//     icon: <FaHandsHelping size={40} color="#db2254" />,
//     title: "Charity / Non-Profit",
//     description:
//       "I volunteer on weekends to help charity or non-profit organizations. All work for these projects is open-source.",
//   },
//   {
//     icon: <FaLightbulb size={40} color="#db2254" />,
//     title: "Collaborations",
//     description:
//       "Open to working on creative ideas with fellow developers and designers. Let's bring innovative ideas to life together.",
//   },
//   {
//     icon: <FaBuilding size={40} color="#db2254" />,
//     title: "Custom Solutions",
//     description:
//       "Looking for companies in need of custom digital solutions. Not seeking employment; focused on delivering tailored projects.",
//   },
// ];

// export default function OpenToWork() {
//   const containerVariants = {
//     hidden: { opacity: 0, y: 20 },
//     visible: {
//       opacity: 1,
//       y: 0,
//       transition: { staggerChildren: 0.2, duration: 0.6 },
//     },
//   };

//   const cardVariants = {
//     hidden: { opacity: 0, y: 20 },
//     visible: { opacity: 1, y: 0, transition: { duration: 0.5 } },
//   };

//   return (
//     <section className={styles.openToWorkSection}>
//       <h2 className={styles.title}>Open to Opportunities</h2>
//       <motion.div
//         className={styles.cardsContainer}
//         variants={containerVariants}
//         initial="hidden"
//         whileInView="visible"
//         viewport={{ once: true }}
//       >
//         {opportunities.map((item, i) => (
//           <motion.div key={i} className={styles.card} variants={cardVariants}>
//             <div className={styles.icon}>{item.icon}</div>
//             <h3 className={styles.cardTitle}>{item.title}</h3>
//             <p className={styles.cardDescription}>{item.description}</p>
//           </motion.div>
//         ))}
//       </motion.div>
//     </section>
//   );
// }

import React from "react";
import { motion } from "framer-motion";
import { FaHandsHelping, FaLightbulb, FaBuilding } from "react-icons/fa";
import styles from "../assets/styles/OpenToWork.module.css";

const opportunities = [
  {
    icon: <FaHandsHelping size={40} />,
    title: "Charity / Non-Profit",
    description:
      "I volunteer on weekends to help charity or non-profit organizations. All work for these projects is open-source.",
  },
  {
    icon: <FaLightbulb size={40} />,
    title: "Collaborations",
    description:
      "Open to working on creative ideas with fellow developers and designers. Let's bring innovative ideas to life together.",
  },
  {
    icon: <FaBuilding size={40} />,
    title: "Custom Solutions",
    description:
      "Looking for companies in need of custom digital solutions. Not seeking employment; focused on delivering tailored projects.",
  },
];

export default function OpenToWork() {
  const containerVariants = {
    hidden: { opacity: 0, y: 30 },
    visible: {
      opacity: 1,
      y: 0,
      transition: { staggerChildren: 0.25, duration: 0.6, ease: "easeOut" },
    },
  };

  const cardVariants = {
    hidden: { opacity: 0, scale: 0.85, y: 20 },
    visible: {
      opacity: 1,
      scale: 1,
      y: 0,
      transition: { duration: 0.6, ease: "easeOut" },
    },
  };

  return (
    <section className={styles.openToWorkSection}>
      <motion.h2
        className={styles.title}
        initial={{ opacity: 0, y: -20 }}
        whileInView={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.7, ease: "easeOut" }}
        viewport={{ once: true }}
      >
        <span className={styles.highlight}>Open to Opportunities</span>
      </motion.h2>

      <motion.div
        className={styles.cardsContainer}
        variants={containerVariants}
        initial="hidden"
        whileInView="visible"
        viewport={{ once: true, amount: 0.2 }}
      >
        {opportunities.map((item, i) => (
          <motion.div key={i} className={styles.card} variants={cardVariants}>
            <div className={styles.iconWrapper}>{item.icon}</div>
            <h3 className={styles.cardTitle}>{item.title}</h3>
            <p className={styles.cardDescription}>{item.description}</p>
          </motion.div>
        ))}
      </motion.div>
    </section>
  );
}
